import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrencyChangeComponent } from './currency-change/currency-change.component';

@NgModule({
  declarations: [CurrencyChangeComponent],
  imports: [CommonModule],
  exports: [CurrencyChangeComponent],
})
export class CurrencyModule {}
